<script setup lang="ts">
import { NXGDSButton, NXGDSButtonVariants, NXGDSButtonSizes } from '@nsftx/seven-nxg-design-system'
import { useLobbyStore } from '@/stores/lobby/lobbyStore'

const { toggleLobby } = useLobbyStore()

const openLobby = () => {
  toggleLobby(true)
}
</script>

<template>
  <div data-cy="openLobbyButton">
    <NXGDSButton
      prepend-icon="globe-a2"
      :variant="NXGDSButtonVariants.secondary"
      :size="NXGDSButtonSizes.big"
      @click="openLobby"
    >
      <span>
        {{ $t('lobby_title') }}
      </span>
    </NXGDSButton>
  </div>
</template>
